module.exports = __webpack_public_path__ + "img/ApprovalTypes.53f1c079.svg";